/*SYSTEM IMPORTS*/
    import React/*, { Component }*/ from 'react'

import Root from 'components/Root'
import { PortalOut } from 'components/Portal'

const RootLayout =  props => (
    <Root className={ props.className }>
        <PortalOut className="modal-wrapper" id="modal-block-wrapper" />
        { props.children }
    </Root>
)

export default RootLayout